// app/javascript/controllers/nested_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["add_item", "template"]
    static values = { isnew: String }

    connect() {
        // If this is a new form, add initial fields
        if (this.isnewValue === 'true') {
            // Add initial fields with a slight delay to ensure DOM is ready
            for (let i = 1; i <= 4; i++) {
                this.add_field(i)
            }
        }
    }

    add_association(event) {
        event.preventDefault()
        this.add_field()
    }

    remove_association(event) {
        event.preventDefault()

        // Find the closest nested-fields container
        const item = event.target.closest(".nested-fields")

        // Mark for destruction
        const destroyInput = item.querySelector("input[name*='_destroy']")
        if (destroyInput) {
            destroyInput.value = '1'
            item.style.display = 'none'
        }
    }

    add_field(i = 0) {
        // Add slight delay to ensure proper DOM manipulation
        requestAnimationFrame(() => {
            // Get template content and replace placeholder
            const content = this.templateTarget.innerHTML.replace(
                /TEMPLATE_RECORD/g,
                `${new Date().valueOf()}${i}`
            )

            // Insert new field before the add button
            this.add_itemTarget.insertAdjacentHTML('beforebegin', content)
        })
    }
}
